import React, { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Alert } from "@domestika-dev/prudencio/dist/atoms/Alert";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { Icon } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { InfoCircle } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { Flex, Row } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";
import WithTooltip from "@domestika-dev/prudencio/dist/HOC/withTooltip/withTooltip";
import When from "../../../../common/When";
import { LiveSessionContext } from "../../context/LiveSessionContext";

export const ScheduleNew = () => {
  const intl = useIntl();
  const { hasActiveSession, nextLiveLoading, onScheduleNew } = useContext(LiveSessionContext);

  const ScheduleNewButton = (props) => (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    <Button size="medium" {...props}>
      <Text size={["tiny", "tiny", "small"]} fontWeight="medium" color="coco">
        <FormattedMessage id="live_sessions.new_live.button" />
      </Text>
    </Button>
  );

  const TooltipButtonWrapper = (props) => (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    <Flex {...props}>
      <ScheduleNewButton disabled />
    </Flex>
  );

  const withTooltipButton = WithTooltip(TooltipButtonWrapper, {
    position: "top",
    message: intl.formatMessage({ id: "live_sessions.new_live.tooltip" }),
    id: "dmstk-live-schedule-new-button-tooltip",
  });

  return (
    <Row flexDirection="column" marginBottom={8}>
      <When condition={hasActiveSession}>
        {() => (
          <Row marginBottom={6}>
            <Alert type="warning" isClosable={false}>
              <Flex justifyContent="flex-start" alignItems="center">
                <Icon size="medium" marginRight={4}>
                  <InfoCircle />
                </Icon>
                <Text size="micro">
                  <FormattedMessage id="live_sessions.new_live.alert" />
                </Text>
              </Flex>
            </Alert>
          </Row>
        )}
      </When>
      <Row marginBottom={4}>
        <Text size="medium" fontWeight="medium" as="h2" textAlign="left">
          <FormattedMessage id="live_sessions.new_live.title" />
        </Text>
      </Row>
      <Row marginBottom={4}>
        <Text as="h3" size="tiny">
          <FormattedMessage id="live_sessions.new_live.body" />
        </Text>
      </Row>
      <Row>
        <When condition={hasActiveSession}>{() => <>{withTooltipButton()}</>}</When>
        <When condition={!hasActiveSession}>
          {() => <ScheduleNewButton action={onScheduleNew} disabled={nextLiveLoading} />}
        </When>
      </Row>
    </Row>
  );
};

export default ScheduleNew;
